import { lazyLoad } from 'utils/loadable';

export const lazyJobListPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'lazyJobListPage', webpackPrefetch: true */ './JobsList'
    ),
  module => module.default,
);

export const lazyCandidatesListPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'lazyCandidatesListPage', webpackPrefetch: true */ './Candidates'
    ),
  module => module.default,
);

export const lazyApplicationsPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'lazyApplicationsPage', webpackPrefetch: true */ './Applications'
    ),
  module => module.default,
);

export const lazyScreeningListPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'lazyScreeningListPage', webpackPrefetch: true */ './ScreeningList'
    ),
  module => module.default,
);

export const lazyManageTemplatesPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'lazyManageTemplatesPage', webpackPrefetch: true */ './Templates/ManageTemplates'
    ),
  module => module.default,
);

export const lazyInterviewListPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'lazyInterviewListPage', webpackPrefetch: true */ './InterviewList'
    ),
  module => module.default,
);

export const jobsRoutes = [
  {
    component: lazyJobListPage,
    path: '/jobs/jobs-list',
    title: 'Job List',
    needsAuth: true,
  },

  {
    component: lazyCandidatesListPage,
    path: '/jobs/candidates',
    title: 'Candidates',
    needsAuth: true,
  },

  {
    component: lazyApplicationsPage,
    path: '/jobs/applications',
    title: 'Applications',
    needsAuth: true,
  },

  {
    component: lazyScreeningListPage,
    path: '/jobs/screening',
    title: 'Screening List',
    needsAuth: true,
  },
  {
    component: lazyManageTemplatesPage,
    path: '/jobs/manage-templates',
    title: 'Manage Templates',
    needsAuth: true,
  },
  {
    component: lazyInterviewListPage,
    path: '/jobs/interviews',
    title: 'Interviews',
    needsAuth: true,
  },
];
